import { disconnect } from '../../../base/connection';
import { getLocalParticipant } from '../../../base/participants';
import { activeGuestShareScreen, additionalModerator, getFullScreenUserId, isRecordingOn } from "../../actions";
import { SignoutUser } from '../../firebase/firebaseActions';
import authService from '../../services/authService';
import { UpdateTopic } from '../device-selection/actions';

export const listeners = () => { 
    const { addCommandListener } = APP.conference.commands;
    addCommandListener("mute-audio-user", ({ value }) => {
        if(value===APP.conference.getMyUserId()){
            APP.conference.muteAudio(true);
        }
    });

    addCommandListener('mute-video-user',({value}) => {
        if(value===APP.conference.getMyUserId()){
            APP.conference.muteVideo(true);
        }
    }); 

    addCommandListener('audio-mute-all',() => {
        if(APP.conference?.getLocalParticipantInfo?.()?.role!=="moderator"){
            APP.conference.muteAudio(true);
        }
    });

    addCommandListener('video-mute-all',() => {
        APP.conference.muteVideo(true);
    });

    addCommandListener('end-for-all',() => {
        authService.logout();
        window.close();
        SignoutUser();
        APP.store.dispatch(disconnect());  
    });

    addCommandListener('full-view-screen-share',({value}) => {  
        APP.store.dispatch(getFullScreenUserId(value)); 
    });

    addCommandListener('update-meeting-title',({value}) => {
        value = JSON.parse(value) 
        const { topic,_roomName :room_name,_meetDetail} = value || {}   
        APP.store.dispatch(
            UpdateTopic({ topic ,room_name})
        );  
        APP.store.dispatch({
            type: "MEETING_DETAILS",
            payload: { ..._meetDetail, topic },
        }); 
    });


    addCommandListener('stopped-screen-share',({value}) => {  
        APP.store.dispatch(getFullScreenUserId(null)); 
    });

    addCommandListener('refresh-to-all',({value}) => {
        let uniquekey = APP.store.getState()["features/nxatel_meet"]?.meeting_details?.uniquekey;
        if(uniquekey!==value){
            swal({
                title: "Session Expired!",
                text: "Host has changed the session, Click to reload!",
                icon: "warning",
                button: "Reload Now",
            }).then(()=>{
                location.reload();
            })
        }            
    }); 
     
    addCommandListener('screen-share',({value}) => {  
        value = JSON.parse(value) 
        const { id, isEnabled } = value || {} 
        let share_screen  = APP.store.getState()["features/nxatel"]?.activate_guest_share_screen??[] 
        if (isEnabled) {
            share_screen = [...share_screen, id]
        }
        else {
            const index = share_screen.indexOf(id)
            if (index > -1) {
                share_screen.splice(index, 1)
            }
        } 
        APP.store.dispatch(activeGuestShareScreen(share_screen))
        if(id === APP.conference.getMyUserId()){ 
            if(isEnabled){
                swal({
                    title: "Screen Share Activated!",
                    text: "You have now access to share your screen!",
                    icon: "info",
                    button: "Ok",
                })
            }else{
                swal({
                    title: "Screen Share Stopped!",
                    text: "You don't have access to share your screen!",
                    icon: "info",
                    button: "Ok",
                })
            }
        }  
    }); 

    addCommandListener('recording-on-off',({value}) => {   
        value = JSON.parse(value) 
        const { id, recordingOn } = value || {}  
        let recording  = APP.store.getState()["features/nxatel"]?.is_recording_on??[] 
        if (recordingOn) {
            recording = [...recording, id]
        }
        else {
            const index = recording.indexOf(id)
            if (index > -1) {
                recording.splice(index, 1)
            }
        } 
        APP.store.dispatch(isRecordingOn(recording)) 
    }); 
    
    
    addCommandListener('role-changed',({value}) => { //Moderator   
        const additional_moderator  = APP.store.getState()["features/nxatel"]?.additional_moderator??[] 
        APP.store.dispatch(additionalModerator([...(additional_moderator || []), value])) 
        if(value===APP.conference.getMyUserId()){
            swal({
                title: "Role Changed!",
                text: "You're now the host of the meeting.",
                icon: "info",
                button: "Ok",
            })
        }
    });

    addCommandListener("sync-conf-data", ({ value }) => {
        const localParticipant = getLocalParticipant(APP.store.getState());
        const { additional_moderators = [], screenSharingPermission = [], id } = JSON.parse(value) 
        if (id === localParticipant.id) { 
            APP.store.dispatch(additionalModerator(additional_moderators)) 
            APP.store.dispatch(activeGuestShareScreen(screenSharingPermission)) 
        }
    });

    addCommandListener('emoji-shared',({value}) => { //Moderator
        console.log("EMOJI_SHARED",value);
    }); 
}

 

 